import React, { useState, useEffect } from 'react';
import { Container, Col, Row, Modal, Button, Card } from 'react-bootstrap';
import styles from './editSheduledInterviewsModal.module.scss';
import SendOfferConfigurations from './sendOfferConfigurations';
import Review from './review';


const SendOfferToCandidateModal = (props) => {
    let [step, setStep] = useState(1);
    let [values, setValues] = useState({});


    function nextPage(value) {
        setStep(value);
    }
    function previousPage(value) {
        setStep(value);
    }

    function updateValues(val) {
        setValues((prevState) => ({
            ...prevState,
            offerLetter: val.offerLetter
        }));

    }



    return (
        <div>

            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5" stroke="#24859A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>
                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Send Offer To Candidate</h2>
                    </div>
                    <Container>
                        <div className="mb-4">
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    VACANCY DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Pipeline Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.pipelineName}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                        <div>
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    CANDIDATE DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Name</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.candidateName}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Email</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.candidateEmail}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Phone</p>
                                        </Col>
                                        <Col>
                                            {(props.viewOfferValues.candidatePhoneCode && props.viewOfferValues.candidatePhoneNumber) ?
                                                <p className={styles.cardValues}>({props.viewOfferValues.candidatePhoneCode})&nbsp;{props.viewOfferValues.candidatePhoneNumber}</p>
                                                :
                                                <p className={styles.cardValues}>Not available</p>
                                            }
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                        <div className='mt-4'>
                            <Card className={styles.modalCard}>
                                <Card.Header className={styles.modalCardHeader}>
                                    OFFER DETAILS
                                </Card.Header>
                                <Card.Body className={styles.modalCardBody}>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Job Title</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.jobTitle}</p>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Allocation</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.allocation ? props.viewOfferValues.allocation : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Description</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}> {props.viewOfferValues.offerDescription ? props.viewOfferValues.offerDescription : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={4}>
                                            <p className={styles.cardTopics}>Package Reference</p>
                                        </Col>
                                        <Col>
                                            <p className={styles.cardValues}>{props.viewOfferValues.packageReference ? props.viewOfferValues.packageReference : 'Not available'}</p>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </div>
                    </Container>

                    <Col sm={{ span: 6, offset: 3 }} className={styles.stepPosition}>
                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>1</div>
                            <div className={(step === 2) ? styles.stepActive : ''}>2</div>
                        </div>
                    </Col>

                    <Container>
                        <div>
                            <p className={styles.stepSubtopicName}>
                                {
                                    step === 1 ? 'Send Offer Configurations'
                                        : 'Review'
                                }
                            </p>
                        </div>
                    </Container>

                    <Container>
                        {/* Rendering Content Goes Here */}
                        {step === 1 && props.showModal === true && <SendOfferConfigurations nextPage={nextPage} updateValues={updateValues} values={values} />}
                        {step === 2 && props.showModal === true && <Review previousPage={previousPage} handleClose={props.handleClose} values={values} offerSessionDetails={props.viewOfferValues} refreshData={props.refreshData} />}
                    </Container>

                </Modal.Body>
            </Modal>
        </div>
    )
}

export default SendOfferToCandidateModal;
